import store from '@/store/index.js'
import axios from 'axios'
import config from '@/config.js'

let axiosWithInterceptors = axios.create()
const exceptions = ['/api/v1/login']

axiosWithInterceptors.interceptors.request.use(
  function(axiosConfig) {
    const authToken = store.access.getToken()

    axiosConfig.baseURL = config.api
    axiosConfig.headers = { 'Content-Type': 'application/json' }
    if (authToken) {
      axiosConfig.headers = {
        'Content-Type': 'application/json',
        Authorization: authToken,
      }
    }

    return axiosConfig
  },
  function(error) {
    return Promise.reject(error)
  }
)

axiosWithInterceptors.interceptors.response.use(
  function(response) {
    return response
  },
  function(error) {
    const requestURL = error?.response?.config?.url ?? ''
    const baseURL = error?.response?.config?.baseURL ?? ''

    const requestPath = requestURL.replace(baseURL, '')

    if (error?.response?.status === 401 && !exceptions.includes(requestPath)) {
      window.localStorage.clear()
      window.location.href = '/welcome'
      location.replace('/welcome')
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  }
)

export const HTTP = axiosWithInterceptors
